import { useState } from "react";
import useQueryParams from "../../hooks/useQueryParams";
import Label from "../../components/form/Label";
import ButtonIconOnly from "../../components/ui/button/ButtonIconOnly";
import { DEFAULT_PER_PAGE } from "../../utilities/constants";

const TableFilter = () => {
  const { updateQueryParam, queryParams } = useQueryParams();
  const [searchValue, setSearchValue] = useState(queryParams.get("search") || "");

  const handleSearchClick = () => {
    updateQueryParam("pageNo", 0);
    updateQueryParam("search", searchValue);
  };

  const resetFilters = () => {
    setSearchValue("");
    updateQueryParam("search", "");
    updateQueryParam("pageNo", 0);
    updateQueryParam("pageSize", DEFAULT_PER_PAGE);
  };

  return (
    <div className="flex flex-col md:flex-row md:items-end gap-3">
      <div className="flex flex-col w-full md:w-64">
        <Label variant="filter" title="Name" />
        <input
          className="search-button-input-hover"
          type="text"
          value={searchValue}
          placeholder="Eg: Streetwear Vibe"
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>

      <div className="flex flex-col md:ml-auto">
        <Label variant="filter" title="&nbsp;" className="hidden md:block" />
        <div className="flex items-center gap-6">
          <button
            onClick={handleSearchClick}
            className="search-button"
          >
            Search
          </button>

          <ButtonIconOnly
            title="Reset"
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 transition flex items-center justify-center"
            icon={
              <svg className="w-5 h-5" viewBox="0 0 512 512" fill="currentColor">
                <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z" />
              </svg>
            }
            onClick={resetFilters}
          />
        </div>
      </div>
    </div>
  );
};
export default TableFilter;
